<div class="modal-header">
    <h4 class="modal-title" i18n>Targetting area</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [formGroup]="form">
    <div class="row g-3">
        <div class="col-12 area-city-col">
            <label for="city" class="form-label" i18n>City</label>
            <div class="position-relative">
                <input type="text" class="form-control" id="city" formControlName="city" (input)="updateCity($event)" placeholder="Search for a city to target" i18n-placeholder>
                <div id="cities" class="list-group">
                    <div class="list-group-item" *ngFor="let city of cities" (click)="selectCity(city)">
                        <span>{{ city.city }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 area-map-col">
            <div id="map"></div>
        </div>
        <div class="col-12">
            <div class="radius-slider-bar">
                <label class="radius-slider-bar__label" for="radius" i18n>Radius</label>
                <input type="range" class="form-range radius-slider-bar__range" id="radius" formControlName="radius" min="1" max="100" step="1">
                <span class="radius-slider-bar__value">{{ form.value.radius }} km</span>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button [disabled]="!form.valid" type="button" class="btn btn-primary" (click)="save()" i18n>Save</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>